//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import searchFilterCheckboxTemplate from '@legacy-components/filters/search-filter-checkbox.html';

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

    /**
     * Checkbox used as a search filter control. When checked, this component sends the provided value to its parent search-filter. When unchecked, this
     * component removes the provided valeufrom its parent search-filter.
     * @param {string} label - label displayed next to the checkbox, will be registered with the Search Filter Service
     * @param {string} labelDecorator - additional label which we be displayed next to the checkbox but not registered with the Search Filter Service
     * @param {string} value - value which this control will output
     */
  curalate.component('searchFilterCheckbox', {
    bindings: {
      label: '@',
      labelDecorator: '@',
      value: '@',
      isDisabled: '<?',
    },
    require: {
      searchFilter: '^searchFilter',
      searchFilterCheckboxGroup: '?^searchFilterCheckboxGroup',
    },
    template: searchFilterCheckboxTemplate,
    controller: ['$scope', '$rootScope',
      function($scope, $rootScope) {
        const self = this;
        let checkedInValueStream = false;

        const calculateCheckboxValueFromOptions = function(options) {
          checkedInValueStream = _(options).contains(self.value);
          return checkedInValueStream;
        };

        $scope.model = {
          checked: false,
        };

        self.$onInit = function() {
          $scope.model.checked = calculateCheckboxValueFromOptions(self.searchFilter.getValue());
          $scope.model.lockedKey = self.searchFilter.isKeyLocked();

          self.searchFilter.registerFilterOptionAlias(self.value, self.label);

          self.searchFilter.getFilterValueStream().subscribe((newState) => {
                        // When the value stream is updated outside of this directive, set the new value of the checkbox accordingly
            $scope.model.checked = calculateCheckboxValueFromOptions(newState);
          });

          if (self.searchFilterCheckboxGroup) {
            self.searchFilterCheckboxGroup.registerGroupValue(self.value);
          }
        };

        $scope.$watch('model.checked', (newValue, oldValue) => {
          if (newValue && !oldValue && !checkedInValueStream) {
            self.searchFilter.addValue(self.value);
            $rootScope.$broadcast('search-filter-checkbox:filter-toggled');
          } else if (oldValue && !newValue && checkedInValueStream) {
            self.searchFilter.removeValue(self.value);
            $rootScope.$broadcast('search-filter-checkbox:filter-toggled');
          }
        });
      },
    ],
  });
})();
